export enum CookiesType {
  Auth = 'auth',
  RefreshToken = 'refreshToken',
  AllowAnalytics = 'ALLOW_GDPR',
}
